<template>
    <div
        class="modal-container"
        @click.self="$emit('close')"
    >
        <slot name="content"></slot>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.modal-container {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: #00000060;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9;
}
</style>
